import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/what-we-do", label: "What We Do" },
  { to: "/pricing", label: "Packages & Pricing" },
  { to: "/software", label: "Software" },
  { to: "/faq", label: "FAQ" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

const TikTokIcon = ({ size = 17 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
  </svg>
);

const SOCIALS = [
  { name: "Instagram", icon: Instagram, href: "https://www.instagram.com/covellicanada/", testid: "social-link-instagram" },
  { name: "TikTok", icon: TikTokIcon, href: "https://www.tiktok.com/@covellica", testid: "social-link-tiktok" },
];

export const Footer = () => (
  <footer
    data-testid="footer-section"
    className="border-t border-slate-200 bg-white"
  >
    <div className="mx-auto flex max-w-7xl flex-col gap-10 px-6 py-16 md:flex-row md:items-start md:justify-between">
      <div>
        <img
          src="/covelli-wordmark-ink.png"
          alt="Covelli logo"
          data-testid="footer-logo"
          className="h-10 w-auto"
        />
        <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-600">
          The marketing agency for companies ready to scale up. Launching Q4
          2026.
        </p>
        <a
          data-testid="footer-email-link"
          href="mailto:team@covelli.ca"
          className="mt-4 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-slate-500 transition-colors duration-300 hover:text-kinetic"
        >
          <Mail size={13} /> team@covelli.ca
        </a>
        <div className="mt-8 flex gap-3">
          {SOCIALS.map((s) => (
            <a
              key={s.name}
              data-testid={s.testid}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Covelli on ${s.name}`}
              className="flex h-11 w-11 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-500 transition-all duration-300 hover:-translate-y-1 hover:border-kinetic hover:text-kinetic"
            >
              <s.icon size={17} />
            </a>
          ))}
        </div>
      </div>
      <nav data-testid="footer-nav" className="flex flex-col gap-3">
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-skybrand">
          Explore
        </span>
        {NAV.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            data-testid={`footer-nav-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className="text-sm text-slate-600 transition-colors duration-300 hover:text-kinetic"
          >
            {l.label}
          </Link>
        ))}
      </nav>
      <div className="flex flex-col gap-2 md:items-end">
        <p className="font-mono text-[11px] uppercase tracking-widest text-kinetic">
          Motto: We sell results
        </p>
        <p className="font-mono text-[11px] uppercase tracking-widest text-slate-400">
          © 2026 Covelli Agency — All rights reserved
        </p>
        <p className="font-mono text-[11px] uppercase tracking-widest text-slate-400">
          Privacy: we email you once. That's it.
        </p>
      </div>
    </div>
  </footer>
);
